export default __webpack_public_path__ + "static/media/ISKO_CLASS-6_SYLLABUS.122274c3.pdf";